import { frontendURL } from '../../../helper/URLHelper';
import LiveVisitorsView from './pages/LiveVisitorsView.vue';

const CONVERSATION_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/live-visitors'),
    name: 'live_visitors_index',
    meta: {
      permissions: CONVERSATION_PERMISSIONS,
    },
    component: LiveVisitorsView,
    props: () => {
      return { inboxId: 0 };
    },
  },
  {
    path: frontendURL(
      'accounts/:accountId/live-visitors/conversations/:conversation_id'
    ),
    name: 'live_visitors_conversation',
    meta: {
      permissions: CONVERSATION_PERMISSIONS,
    },
    component: LiveVisitorsView,
    props: route => {
      return {
        inboxId: 0,
        conversationId: route.params.conversation_id,
      };
    },
  },
];
